// @internal
export function isString(value) {
    return typeof value === 'string';
}
